import apiClient from '../axios.js';

const base = '/salon';

export const salonService = {
  uploadStylistAvatar: file => {
    const formData = new FormData();
    formData.append('file', file);
    return apiClient.post('/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  listSettings: () => apiClient.get(`${base}/settings`),
  getSettings: storeId => apiClient.get(`${base}/settings/${storeId}`),
  updateSettings: (storeId, data) => apiClient.put(`${base}/settings/${storeId}`, data),

  listStylists: (params = {}) => apiClient.get(`${base}/stylists`, { params }),
  listLineFriends: (params = {}) => apiClient.get(`${base}/stylist-line-friends`, { params }),
  getStylist: id => apiClient.get(`${base}/stylists/${id}`),
  createStylist: data => apiClient.post(`${base}/stylists`, data),
  updateStylist: (id, data) => apiClient.put(`${base}/stylists/${id}`, data),
  deactivateStylist: id => apiClient.delete(`${base}/stylists/${id}`),

  listServices: (params = {}) => apiClient.get(`${base}/services`, { params }),
  getService: id => apiClient.get(`${base}/services/${id}`),
  createService: data => apiClient.post(`${base}/services`, data),
  updateService: (id, data) => apiClient.put(`${base}/services/${id}`, data),
  deactivateService: id => apiClient.delete(`${base}/services/${id}`),

  listSchedules: (params = {}) => apiClient.get(`${base}/schedules`, { params }),
  getSchedule: id => apiClient.get(`${base}/schedules/${id}`),
  createSchedule: data => apiClient.post(`${base}/schedules`, data),
  createSchedules: data => apiClient.post(`${base}/schedules/batch`, data),
  updateSchedule: (id, data) => apiClient.put(`${base}/schedules/${id}`, data),
  deleteSchedule: id => apiClient.delete(`${base}/schedules/${id}`),
  previewSchedule: id => apiClient.post(`${base}/schedules/${id}/preview`),
  getScheduleReservationLocks: (id, data) => (
    apiClient.post(`${base}/schedules/${id}/reservation-locks`, data)
  ),
  publishSchedule: id => apiClient.post(`${base}/schedules/${id}/publish`),

  listClosures: (params = {}) => apiClient.get(`${base}/store-closures`, { params }),
  getClosure: id => apiClient.get(`${base}/store-closures/${id}`),
  previewClosure: data => apiClient.post(`${base}/store-closures/preview`, data),
  createClosure: data => apiClient.post(`${base}/store-closures`, data),
  updateClosure: (id, data) => apiClient.put(`${base}/store-closures/${id}`, data),
  deactivateClosure: id => apiClient.delete(`${base}/store-closures/${id}`),

  listBlocks: (params = {}) => apiClient.get(`${base}/booking-blocks`, { params }),
  getBlock: id => apiClient.get(`${base}/booking-blocks/${id}`),
  previewBlock: data => apiClient.post(`${base}/booking-blocks/preview`, data),
  createBlock: data => apiClient.post(`${base}/booking-blocks`, data),
  updateBlock: (id, data) => apiClient.put(`${base}/booking-blocks/${id}`, data),
  deactivateBlock: id => apiClient.delete(`${base}/booking-blocks/${id}`),

  getAvailability: data => apiClient.post(`${base}/availability`, data),
  getAvailableDates: data => apiClient.post(`${base}/availability/dates`, data),
  listReservations: (params = {}) => apiClient.get(`${base}/reservations`, { params }),
  getReservation: id => apiClient.get(`${base}/reservations/${id}`),
  createReservation: data => apiClient.post(`${base}/reservations`, data),
  updateReservation: (id, data) => apiClient.put(`${base}/reservations/${id}`, data),
  cancelReservation: (id, reason) => apiClient.post(`${base}/reservations/${id}/cancel`, { reason }),
  updateReservationStatus: (id, status, reason = null) =>
    apiClient.put(`${base}/reservations/${id}/status`, { status, reason })
};
